import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { NOT_LOADED } from "../Infra/RemoteData";
import { addDisplayName } from "../Infra/display-name";
import { LoadingPlaceholder } from "./LoadingPlaceholder";
import { NotFound, ResearcherStudiesDetailViewParent } from "./ResearcherStudiesDetailView.styles";
import { ResearcherStudiesDetailViewModel } from "./ResearcherStudiesDetailViewModel";
import { useViewModel } from "./useViewModel";
import { HXDesktopProjectDetails } from "./HXDesktopProjectDetails";
import { TabTitleBar, TabTitleButtons, Title } from "./StudyManagerShared.styles";
import Edit from "@mui/icons-material/Edit";
import { HXButton } from "./HXButton";
export const ResearcherStudiesDetailView = observer((props) => {
    const model = useViewModel(ResearcherStudiesDetailViewModel, props.container);
    const _study = model.study;
    if (_study === NOT_LOADED) {
        return _jsx(LoadingPlaceholder, { w: 10, h: 60 });
    }
    if (!_study) {
        return _jsx(NotFound, { children: "Study not found" });
    }
    const study = _study;
    return (_jsxs(ResearcherStudiesDetailViewParent, { children: [_jsxs(TabTitleBar, { children: [_jsx(Title, { children: "Patient details" }), _jsx(TabTitleButtons, { children: model.showEditProjectButton && (_jsx(HXButton, { startIcon: _jsx(Edit, {}), onClick: () => model.editProject(), children: "Edit" })) })] }), _jsx(HXDesktopProjectDetails, { study: study, container: props.container, showTypesOfData: true })] }));
});
addDisplayName(ResearcherStudiesDetailView, "ResearcherStudiesDetailView");
